import FillMethod from './fillers/FillMethod'
import Logger from './Log'
import { shuffleArray } from './utils'

const Log = Logger.for('FillManager')

class FillManager {
  constructor () {
    this._methods = []
  }

  register (fillMethod) {
    Log.debug('Registered fill method ' + fillMethod.name())
    if (!(fillMethod instanceof FillMethod)) throw new Error('Not valid instance of a FillMethod')

    this._methods.push(fillMethod)
  }

  /**
   * @returns {this} List of fill methods sorted by highest to lowest
   * estimated fill value. Will pre-shuffle to randomize order of
   * equally valued fill methods
   */
  methods () {
    return shuffleArray(this._methods).sort((a, b) => b.estValue() - a.estValue())
  }
}

export default new FillManager()
